import $ from 'jquery';
import {fetchRemoteResult} from "../../../../Core/Api/api-util";

const apiEndpoint = '/api/MANGL/AnalysisSelection/';
const permissionGrantType = {
    read: 1,
    write: 2,
    delete: 4
};

export default {
    filter(model){
        const params = {
            startDate: model.startDate.toISOString(),
            endDate: model.endDate.toISOString(),
            divisionId: model.divisionId
        };
        
        const paramsKeys = Object.keys(params);
        
        //Take every non-null/non-undefined item not always present in our params object
        Object.keys(model).forEach(modelKey => {
            if(paramsKeys.indexOf(modelKey) !== -1 || model[modelKey] === null || model[modelKey] === undefined){
                return;
            }
            
            params[modelKey] = model[modelKey];
        });
        
        const url = `${apiEndpoint}Filter?${$.param(params)}`;
        
        // let url = [
        //     `${apiEndpoint}Filter?`,
        //     `startDate=${model.startDate.toISOString()}`,
        //     `&endDate=${model.endDate.toISOString()}`,
        //     `&divisionId=${model.divisionId}`
        // ];
        //
        // if(model.agentId) {
        //     url.push(`&agentId=${model.agentId}`);
        // }
        //
        // if(model.sale) {
        //     url.push(`&sale=${model.sale}`);
        // }

        return fetchRemoteResult(url);
    },
    getAgents(divisionId) {
        return fetchRemoteResult(`${apiEndpoint}agents?divisionId=${divisionId}`);
    },
    getOffers(divisionId) {
        return fetchRemoteResult(`${apiEndpoint}offers?divisionId=${divisionId}`);
    },
    getSuppliers(divisionId) {
        return fetchRemoteResult(`${apiEndpoint}suppliers?divisionId=${divisionId}`);
    },
    getContractTypes(divisionId) {
        return fetchRemoteResult(`${apiEndpoint}contractTypes?divisionId=${divisionId}`);
    },
    insertCalls(calls) {
        return fetchRemoteResult(apiEndpoint + 'calls', 
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(calls)
        });
    },
    startAnalysis(calls) {
        return fetchRemoteResult(apiEndpoint + 'calls', 
        {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(calls)
        });
    },
    clearQueue(calls) {
        return fetchRemoteResult(apiEndpoint + 'calls', 
        {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(calls)
        });
    },
    getCalls(status) {
        return fetchRemoteResult(`${apiEndpoint}calls?status=${status}`);
    },
    validateControlPermission(grantType) {
        return fetchRemoteResult(`${apiEndpoint}validate?grantType=${grantType}`);
    },
    apiEndpoint,
    permissionGrantType
};
